module.exports = __webpack_public_path__ + "static/media/ic_freeehandT.aa77f353.svg";